<template>
  <div>
    <ErrorAlert
      :show="alert.error"
      :message="alert.message"
      @hide-alert="hideError"
    />
    <SuccessAlert
      :show="alert.success"
      :message="alert.message"
      @hide-alert="hideSuccess"
    />

    <div class="container-fluid p-0" id="order-reports">
      <div class="row">
        <div class="col-auto">
          <h3><strong>Order</strong> reports</h3>
          <p class="mt-4 mb-0">Report name and report type are required</p>
        </div>
      </div>

      <div class="row mt-3 mb-0 form">
        <div class="col-md-8 col-xl-8 col-12">
          <div class="form-card">
            <b-form id="order-report-form">
              <div class="report-type-name-grid mt-3">
                <div class="report-type-col">
                  <b-form-group>
                    <label class="mt-1 report-label">Report type</label>
                    <b-form-select
                      v-model="formData.reportType"
                      :options="typesOpt"
                      @change="onChangeReportType"
                      class="input-height mt-1"
                      ref="reportType"
                      id="reportType"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="report-name-col">
                  <b-form-group>
                    <label class="mt-0 report-label">Report name</label>
                    <b-form-input
                      v-model="formData.reportName"
                      type="text"
                      placeholder="ORDER_REPORT_EXAMPLE"
                      class="input-height mt-1 upper"
                      ref="reportName"
                      id="reportName"
                    ></b-form-input>
                    <div class="input-box">
                      <p v-show="checkRepName" class="input-alert mb-0 mt-0">
                        Special characters are not allowed
                      </p>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div
                v-if="
                  formData.reportType === 'ORDER_REPORT_V_DAY' ||
                    formData.reportType === 'ORDER_REPORT_NEXT_DAY'
                "
                class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <div class="relative flex items-start">
                  <b-form-checkbox v-model="formData.deliveryWindowExcluded">
                    Delivery Window Restrict(Exclude selected delivery window)
                  </b-form-checkbox>
                </div>
                <div class="relative flex items-start">
                  <select
                    v-model="formData.deliveryWindow"
                    id="deliveryWindow"
                    name="deliveryWindow"
                    ref="deliveryWindow"
                    class="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                  >
                    <option
                      v-for="(optType, index) in deliveryWindowOpt"
                      :key="index"
                      :value="optType.value"
                    >
                      {{ optType.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mt-3">
                <div
                  class="col-sm"
                  v-if="
                    formData.reportType == 'ORDER_REPORT_NON_FLORAL_GIFTSETS'
                  "
                >
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Excluding regions (For Canada Giftset Report, you can
                      check this. For Montreal, uncheck this)</label
                    >
                    <b-form-checkbox
                      v-model="excludingRegions"
                      value="true"
                      unchecked-value="false"
                    ></b-form-checkbox>
                  </b-form-group>
                </div>
              </div>

              <b-form-group class="mt-2">
                <p class="report-label mb-2">
                  Regions
                  <span
                    >(Do not need to select for Error Report, Not Pulled Report
                    and Not Sent Report)</span
                  >
                </p>
                <div class="row">
                  <div
                    v-for="(region, index) in regionsOpt"
                    :key="index"
                    class="col-md-6 col-lg-4 col-6"
                  >
                    <b-form-checkbox
                      :value="region.value"
                      v-model="formData.deliveryRegion"
                      >{{ region.text }}</b-form-checkbox
                    >
                  </div>
                </div>
              </b-form-group>

              <b-form-group v-if="formData.reportType == 'ORDER_REPORT_V_DAY'">
                <label class="mt-0 report-label">Delivery date</label>
                <b-form-datepicker
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                  v-model="deliveryDate"
                  class="mb-2"
                ></b-form-datepicker>
              </b-form-group>

              <div class="delivery-time-tag-grid">
                <div class="delivery-time-col">
                  <label class="mt-0 report-label">Description</label>
                  <b-form-input
                    v-model="formData.description"
                    type="text"
                    placeholder="Description"
                    class="input-height mt-1 upper"
                  ></b-form-input>
                </div>
                <div class="skipped-tag-col">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >About Arrangement Bouquet</label
                    >
                    <b-form-select
                      v-model="aboutArrangement"
                      :options="aboutArrangementOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="delivery-time-tag-grid">
                <div class="delivery-time-col">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Default Delivery Start Time(12:00PM)</label
                    >
                    <b-form-input
                      v-model="formData.defaultDeliveryStartTime"
                      type="text"
                      placeholder="Default Delivery Start Time(12:00PM)"
                      class="input-height mt-1 upper"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="skipped-tag-col">
                  <b-form-group>
                    <label class="mt-0 report-label">Skipped Tag</label>
                    <b-form-input
                      v-model="formData.skippedTag"
                      type="text"
                      placeholder="Please input tag name"
                      class="input-height mt-1 upper"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="consolidate-sort-grid">
                <div class="consolidate-col">
                  <b-form-group>
                    <label class="mt-0 report-label">Consolidate Order</label>
                    <b-form-select
                      v-model="formData.consolidateOrder"
                      :options="consolidateOrderOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="sort-col">
                  <b-form-group>
                    <label class="mt-0 report-label">Sort by Header Name</label>
                    <b-form-select
                      v-model="formData.sortHeaderName"
                      :options="sortHeaderNameOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="additional-report-grid">
                <div class="additional-type-col">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Additional Report Type</label
                    >
                    <b-form-select
                      v-model="formData.additionalReportType"
                      :options="additionalReportTypesOpt"
                      @change="onChangeAdditionalReportType"
                      class="input-height mt-1"
                      ref="additionalReportType"
                      id="additionalReportType"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="additional-name-col">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Additional Report Name</label
                    >
                    <b-form-input
                      v-model="formData.additionalReportName"
                      type="text"
                      placeholder="Enter Additional Report Name"
                      class="input-height mt-1 upper"
                      ref="additionalReportName"
                      id="additionalReportName"
                    ></b-form-input>
                    <div class="input-box">
                      <p v-show="checkRepName" class="input-alert mb-0 mt-0">
                        Special characters are not allowed
                      </p>
                    </div>
                  </b-form-group>
                </div>
                <div class="additional-file-col">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Additional File Type</label
                    >
                    <b-form-select
                      v-model="formData.additionalFileType"
                      :options="additionalFileTypesOpt"
                      class="input-height mt-1"
                      ref="additionalFileType"
                      id="additionalFileType"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <b-button
                type="button"
                variant="primary"
                class="submit-button"
                v-if="enableButton"
                @click="genReport"
              >
                Submit report
              </b-button>
              <b-button type="button" class="disabled-button" disabled v-else>
                Submit report
              </b-button>
            </b-form>
          </div>
        </div>
      </div>
      <div class="page-break"></div>
    </div>
  </div>
</template>

<script>
import ErrorAlert from "@/components/alerts/error.vue";
import SuccessAlert from "@/components/alerts/success.vue";
import { uuid } from "vue-uuid";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  components: {
    ErrorAlert,
    SuccessAlert
  },
  data() {
    return {
      deliveryDate: "",
      excludingRegions: "false",
      aboutArrangement: "",
      formData: {
        uuid: uuid.v4(),
        reportName: "",
        description: "",
        reportType: "",
        errorCheckReport: false,
        fileType: "excel",
        deliveryDateFilterIncluded: true,
        noOfDaysToDeliveryDate: 0,
        deliveryDate: "",
        filtersForRestUrl: {
          fulfillmentStatus: "unshipped",
          fields:
            "id,name,note,discount_codes,line_items,shipping_address,shipping_lines,tags,created_at,email,note_attributes,customer",
          status: "open"
        },
        deliveryRegion: [],
        excludingRegion: [],
        provinceCode: "",
        deliveryWindowExcluded: false,
        deliveryWindow: [
          "(1pm - 6pm)",
          "(1pm - 5pm)",
          "(3pm - 6pm)",
          "(3pm - 7pm)"
        ],
        createAtIncluded: false,
        hours: 0,
        minutes: 0,
        defaultDeliveryStartTime: "",
        skippedTag: "",
        sortHeaderName: "order-line_items-name",
        consolidateOrder: false,
        additionalReportType: "",
        additionalFileType: "",
        additionalReportName: ""
      },

      alert: {
        error: false,
        message: ""
      },

      regionsOpt: [
        { text: "Halifax", value: "Halifax" },
        { text: "Maritimes", value: "Maritimes" },
        { text: "Québec_City", value: "Québec_City" },
        { text: "Montreal", value: "Montreal" },
        { text: "Montreal_Surrounding", value: "Montreal_Surrounding" },
        { text: "Ottawa", value: "Ottawa" },
        { text: "Kingston", value: "Kingston" },
        { text: "Hamilton", value: "Hamilton" },
        { text: "Toronto", value: "Toronto" },
        { text: "Kitchener_Waterloo", value: "Kitchener_Waterloo" },
        { text: "London", value: "London" },
        { text: "Really_Rural_MB", value: "Really_Rural_MB" },
        { text: "Rural_MB", value: "Rural_MB" },
        { text: "Winnipeg_Surrounding", value: "Winnipeg_Surrounding" },
        { text: "Winnipeg", value: "Winnipeg" },
        { text: "Regina", value: "Regina" },
        { text: "Saskatoon", value: "Saskatoon" },
        { text: "Southern_AB", value: "Southern_AB" },
        { text: "Calgary", value: "Calgary" },
        { text: "Edmonton", value: "Edmonton" },
        { text: "Northern_AB", value: "Northern_AB" },
        { text: "Okanagan", value: "Okanagan" },
        { text: "Kelowna_Surrounding", value: "Kelowna_Surrounding" },
        { text: "Kelowna", value: "Kelowna" },
        { text: "Surrounding_VAC", value: "Surrounding_VAC" },
        { text: "Langley", value: "Langley" },
        { text: "Vancouver", value: "Vancouver" },
        { text: "Victoria", value: "Victoria" }
      ],

      typesOpt: [
        { text: "Select an option", value: null },
        { text: "Same day", value: "ORDER_REPORT_SAME_DAY" },
        { text: "Next day", value: "ORDER_REPORT_NEXT_DAY" },
        { text: "Specific day", value: "ORDER_REPORT_V_DAY" },
        { text: "Curated Gift Box", value: "ORDER_REPORT_NON_FLORAL_GIFTSETS" },
        { text: "Error Report", value: "ERROR_REPORT" },
        { text: "Not Pulled Report", value: "NOT_PULLED_REPORT" },
        { text: "Not Sent Report", value: "NOT_SENT_REPORT" },
        { text: "Flashbox Report", value: "ORDER_REPORT_FLASHBOX" },
        { text: "Lakewood Report", value: "LAKEWOOD_REPORT" }
      ],
      additionalReportTypesOpt: [
        { text: "Select an option", value: "" },
        { text: "Maximum Report", value: "ADDITIONAL_MAXIMUM_REPORT" },
        { text: "Gopher Report", value: "ADDITIONAL_GOPHER_IT_REPORT" },
        { text: "Flashbox Report", value: "ADDITIONAL_FLASHBOX_REPORT" },
        { text: "Midland Report", value: "ADDITIONAL_MIDLAND_REPORT" },
        {
          text: "Go Speed Logistics Report",
          value: "ADDITIONAL_GO_SPEED_LOGISTICS_REPORT"
        }
      ],
      additionalFileTypesOpt: [
        { text: "Select an option", value: "" },
        { text: "Excel", value: "excel" },
        { text: "CSV", value: "csv" }
      ],
      consolidateOrderOpt: [
        { text: "False", value: false },
        { text: "True", value: true }
      ],
      sortHeaderNameOpt: [
        { text: "Bouquet and Size", value: "order-line_items-name" },
        { text: "Bouquet", value: "Bouquet" },
        { text: "Recipient_Name", value: "Recipient_Name" }
      ],
      deliveryWindowOpt: [
        { text: "", value: [] },
        {
          text: "Late afternoon",
          value: [
            "(1pm - 6pm)",
            "(1pm - 5pm)",
            "(3pm - 6pm)",
            "(3pm - 7pm)",
            "(2pm - 6pm)"
          ]
        },
        { text: "Evening", value: ["evening"] },
        { text: "Midday", value: ["midday"] },
        { text: "Midday and Evening", value: ["midday", "evening"] }
      ],
      aboutArrangementOpt: [
        { text: "Regular Pull", value: "" },
        { text: "Excluding Arrangement Orders", value: "1" },
        { text: "Only Arrangement Orders", value: "2" }
      ]
    };
  },
  async created() {
    if (this.$route.params.editedItem) {
      this.formData = this.$route.params.editedItem;
      if (
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
        this.formData.reportType === "ORDER_REPORT_MAXIMUM" ||
        this.formData.reportType === "ORDER_REPORT_FLASHBOX"
      ) {
        this.formData.noOfDaysToDeliveryDate = 1;
      }

      if (
        this.formData.reportType === "ORDER_REPORT_V_DAY" &&
        (!this.formData.deliveryDate ||
          this.formData.deliveryDate === "Invalid Date") &&
        this.formData.noOfDaysToDeliveryDate === 2
      ) {
        this.formData.reportType = "ORDER_REPORT_NEXT_DAY_PLUS_1";
      }

      this.aboutArrangement = "";
      if (
        this.formData.excludedBouquets &&
        this.formData.excludedBouquets.length > 0
      ) {
        this.aboutArrangement = "1";
      }
      if (
        this.formData.includedBouquets &&
        this.formData.includedBouquets.length > 0
      ) {
        this.aboutArrangement = "2";
      }
      console.log("aboutArrangement:", this.aboutArrangement);
    }
    await this.axios
      .get(process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/regions", {
        headers: {
          Authorization: "Bearer " + this.$store.getters.idToken
        }
      })
      .then(response => {
        if (response.data && response.data.records) {
          this.regionsOpt = [];
          for (const data of response.data.records) {
            const region = {
              text: data.name + "(" + data.province_code + ")",
              value: data.tag,
              provinceCode: data.province_code
            };
            this.regionsOpt.push(region);
          }
          this.regionsOpt.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
      });
  },
  methods: {
    onChangeReportType() {
      if (
        this.formData.reportType === "ORDER_REPORT_V_DAY" ||
        this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY_PLUS_1" ||
        this.formData.reportType === "ORDER_REPORT_NON_FLORAL_GIFTSETS"
      ) {
        this.formData.skippedTag = "pulled,sent";
        this.formData.sortHeaderName = "order-line_items-name";
        this.formData.consolidateOrder = true;
      } else {
        this.formData.skippedTag = "";
        this.formData.consolidateOrder = false;
      }

      this.formData.additionPull =
        this.formData.reportType === "ORDER_REPORT_V_DAY";
    },
    onChangeAdditionalReportType() {
      if (
        this.formData.additionalReportType === "ADDITIONAL_GOPHER_IT_REPORT" ||
        this.formData.additionalReportType ===
          "ADDITIONAL_GO_SPEED_LOGISTICS_REPORT"
      ) {
        this.formData.additionalFileType = "csv";
      } else {
        this.formData.additionalFileType = "";
        this.formData.additionalReportName = "";
      }
    },
    validateForm() {
      if (!this.formData.reportType) {
        this.alert.error = true;
        this.alert.message = "Please choose report type";
        this.$refs["reportType"].focus();
        return false;
      }
      if (!this.formData.reportName) {
        this.alert.error = true;
        this.alert.message = "Please input report name";
        this.$refs["reportName"].focus();
        return false;
      }

      if (this.formData.additionalReportType) {
        if (!this.formData.additionalReportName) {
          this.alert.error = true;
          this.alert.message = "Please input additional report name";
          this.$refs["additionalReportName"].focus();
          return false;
        }
        if (!this.formData.additionalFileType) {
          this.alert.error = true;
          this.alert.message = "Please choose additional file type";
          this.$refs["additionalFileType"].focus();
          return false;
        }
      }
      if (
        this.formData.reportType === "ORDER_REPORT_V_DAY" ||
        this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY_PLUS_1" ||
        this.formData.reportType === "ORDER_REPORT_NON_FLORAL_GIFTSETS"
      ) {
        console.log("region:", this.formData.deliveryRegion);
        if (
          !this.formData.deliveryRegion ||
          this.formData.deliveryRegion.length === 0
        ) {
          this.alert.error = true;
          this.alert.message = "Please choose region";
          // this.$refs["cronText"].focus();
          return false;
        }
      }
      // Clear any previous errors if validation passes
      this.alert.error = false;
      this.alert.message = "";
      return true;
    },
    async genReport() {
      const res = this.validateForm();
      if (res === false) {
        console.log("res:", res);
        return;
      }
      this.formData.reportName = this.formData.reportName
        .trim()
        .replace(/\s/g, "_")
        .toUpperCase();
      if (this.formData.deliveryRegion && this.formData.deliveryRegion.length > 0) {
        const region = this.formData.deliveryRegion[0];
        this.formData.provinceCode = (
          this.regionsOpt.find(t => {
            return t.text.toLowerCase() === region.toLowerCase();
          }) || {}
        ).provinceCode;
      }

      if (
        this.formData.reportType === "ORDER_REPORT_V_DAY" ||
        this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY"
      ) {
        this.formData.sortHeaderName = "Recipient_Name";
        this.formData.consolidateOrder = true;
      }

      if (this.formData.reportType === "ORDER_REPORT_V_DAY") {
        this.formData.deliveryDateFilterIncluded = false;
        this.formData.deliveryDate = dayjs(this.deliveryDate, "YYYY-MM-DD")
          .tz("America/Winnipeg")
          .format("MM/DD/YYYY");
      }
      if (this.formData.reportType === "ORDER_REPORT_SAME_DAY") {
        this.formData.noOfDaysToDeliveryDate = 0;
      } else if (this.formData.reportType === "LAKEWOOD_SAME_DAY_REPORT") {
        this.formData.reportType = "LAKEWOOD_REPORT";
        this.formData.skippedTag = "pulled,sent";
        this.formData.noOfDaysToDeliveryDate = 0;
      } else if (this.formData.reportType === "LAKEWOOD_NEXT_DAY_REPORT") {
        this.formData.reportType = "LAKEWOOD_REPORT";
        this.formData.skippedTag = "pulled,sent";
        this.formData.noOfDaysToDeliveryDate = 1;
      } else if (this.formData.reportType === "SHR_SAME_DAY_REPORT") {
        this.formData.reportType = "SHR_REPORT";
        this.formData.skippedTag = "pulled,sent";
        this.formData.noOfDaysToDeliveryDate = 0;
      } else if (this.formData.reportType === "SHR_NEXT_DAY_REPORT") {
        this.formData.reportType = "SHR_REPORT";
        this.formData.skippedTag = "pulled,sent";
        this.formData.noOfDaysToDeliveryDate = 1;
      } else if (
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
        this.formData.reportType === "ORDER_REPORT_MAXIMUM"
      ) {
        this.formData.noOfDaysToDeliveryDate = 1;
      } else if (this.formData.reportType === "ORDER_REPORT_NEXT_DAY_PLUS_1") {
        this.formData.noOfDaysToDeliveryDate = 2;
        this.formData.reportType = "ORDER_REPORT_V_DAY";
      } else if (this.formData.reportType === "ERROR_REPORT") {
        this.formData.errorCheckReport = true;
        this.formData.deliveryDateFilterIncluded = false;
      }
      if (this.formData.reportType === "ORDER_REPORT_NON_FLORAL_GIFTSETS") {
        this.formData.filtersForRestUrl.fields =
          "id,name,note,discount_codes,line_items,billing_address,shipping_address,shipping_lines,tags,created_at,email,note_attributes,customer";
        if (this.excludingRegions === "true") {
          this.formData.excludingRegion = this.formData.deliveryRegion;
          this.formData.deliveryRegion = [];
        }
      }

      if (this.aboutArrangement) {
        if (this.aboutArrangement === "1") {
          this.formData.excludedBouquets = [
            "The Snowfall Arrangement",
            "The Crimson Arrangement"
          ];
        } else if (this.aboutArrangement === "2") {
          this.formData.includedBouquets = [
            "The Snowfall Arrangement",
            "The Crimson Arrangement"
          ];
        }
      }

      console.log("formData:", this.formData);
      await this.axios.post(
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/config",
        this.formData,
        {
          headers: {
            Authorization: "Bearer " + this.$store.getters.idToken
          }
        }
      );

      this.alert = {
        message: "Order report submitted successfully",
        error: false,
        success: true
      };
    },
    hideError() {
      this.alert.error = false;
    },
    hideSuccess() {
      this.alert.success = false;
    }
  },
  computed: {
    checkRepName() {
      if (
        this.formData.reportName &&
        !/^[0-9A-Za-z_ ]+$/.test(this.formData.reportName)
      ) {
        return true;
      }
      return false;
    },
    enableButton() {
      if (
        (this.formData.reportType === "ERROR_REPORT" ||
          this.formData.reportType === "NOT_PULLED_REPORT" ||
          this.formData.reportType === "NOT_SENT_REPORT" ||
          this.formData.deliveryRegion?.length > 0) &&
        this.formData.reportType &&
        this.formData.reportName &&
        /^[0-9A-Za-z_ ]+$/.test(this.formData.reportName)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/form.scss";

.card {
  width: 100%;
  border: none;
}

.report-label {
  font-weight: 600;

  .weight {
    font-weight: 400;
  }

  span {
    font-weight: 400;
  }
}

.upper {
  text-transform: uppercase;
}

#checkbox-group,
.custom-select a:hover,
a:active,
a:focus {
  outline: 0;
}

.page-break {
  width: 100%;
  height: 52px;
}

.report-type-name-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.report-type-col,
.report-name-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .report-type-name-grid {
    grid-template-columns: 1fr !important;
  }
}

.delivery-time-tag-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.delivery-time-col,
.skipped-tag-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .delivery-time-tag-grid {
    grid-template-columns: 1fr !important;
  }
}

.consolidate-sort-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.consolidate-col,
.sort-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .consolidate-sort-grid {
    grid-template-columns: 1fr !important;
  }
}

.additional-report-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr !important;
  gap: 15px !important;
}

.additional-type-col,
.additional-name-col,
.additional-file-col {
  min-width: 0 !important;
}

@media (max-width: 768px) {
  .additional-report-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .additional-report-grid {
    grid-template-columns: 1fr 1fr !important;
  }
}
</style>
